import { connect } from 'react-redux';

import { closeHeaderNotification } from 'store/modules/app/actions';
import { getHeaderNotification } from 'store/modules/app/selectors';

import HeaderNotification from './HeaderNotification';

const mapStateToProps = (state) => ({
  open: getHeaderNotification(state),
});

const mapDispatchToProps = (dispatch) => ({
  onClose: () => dispatch(closeHeaderNotification()),
});

export default connect(mapStateToProps, mapDispatchToProps)(HeaderNotification);
